import React, { Component }  from 'react';
import AdminTable            from '../../components/AdminTable.jsx';
import PageHeaderBar         from '../../components/PageHeaderBar.jsx';
import Modal                 from '../../components/Modal.jsx';
import ContributorForm       from './ContributorForm.jsx';
import { contributorRecord } from './contributorRecord.js';
import { statusTypesLookup } from '../../data/refData.js';
import { fetchEndpoint,
         imageArray }        from '../../functions.js';

class Contributors extends Component {

  constructor() {
    super();
    this.tableRef = React.createRef();
    this.formRef  = React.createRef();
    this.state = {
      mode          : 'list',   // list | create | edit
      currentItem   : {},       // The contributor being created or manipulated
      deleteModal     : false,    // Toggles visibility of modal
    };
  }

  onCloseModal      = ()     => this.setState({ deleteModal: false });
  gotoListMode      = ()     => this.setState({ mode: 'list' });
  createItem        = ()     => this.setState({ currentItem : contributorRecord(null, 'create'), mode : 'create' });
  editItem          = (item) => this.setState({ currentItem : contributorRecord(item, 'edit'  ), mode : 'edit'   });
  copyItem          = (item) => this.setState({ currentItem : contributorRecord(item, 'create'), mode : 'create' });
  promptForDeletion = (item) => this.setState({ currentItem : item, deleteModal: true });

  onSaveItem = async () => {
    const { notifySuccess, notifyError } = this.props;
    const { mode } = this.state;
    // get the form item data via its reference
    const { item } = this.formRef.current.state;
    item.con_images = imageArray(item.con_images);

    let saveURL = '/api/contributors';
    if (mode === 'edit') saveURL += '/'+ item._id;

    await fetchEndpoint({
      url       : saveURL,
      body      : item,
      onSuccess : () => {
        notifySuccess(`${item.con_name} saved`);
        this.setState({ mode : 'list' }, () => {
          this.tableRef.fireFetchData();
        });
      },
      onError   : (error) => {
        console.log('error during save', error);
        notifyError('sorry there was an error and you cannot continue');
      },
    });
  }

  onDeleteCurrentItem = async () => {
    const { currentItem } = this.state;
    const { notifySuccess, notifyError } = this.props;
    await fetchEndpoint({
      url       : '/api/contributors/' + currentItem._id,
      method    : 'DELETE',
      onSuccess : () => {
        notifySuccess(`Contributor deleted: ${currentItem.con_name}`);
        this.setState({ mode : 'list' }, () => {
          this.onCloseModal();
          this.tableRef.fireFetchData();
        });
      },
      onError   : (error) => {
        console.log('error during delete', error);
        notifyError('sorry there was an error and you cannot continue');
      },
    });
  }

  render() {

    const { notifyError } = this.props;
    const { mode, currentItem, deleteModal } = this.state;
    const columns = [
      { 
        Header    : 'Image',
        id        : 'con_image',
        accessor  : 'con_images[0].fileURL',
        maxWidth  : 120,
        resizable : false,
        Cell      : field => (<img className="admin-table-image" src={field.value} alt="" />),
      },
      { 
        Header    : 'Name',
        id        : 'con_name',
        accessor  : 'con_name',
        resizable : true,
      },
      { 
        Header    : 'Company',
        id        : 'company_name',
        accessor  : '_xrefs.company.com_name',
        sortable  : true,
        maxWidth  : 220,
        resizable : false,
      },
      { 
        Header    : '# Shares',
        accessor  : '_counts.shares',
        maxWidth  : 80,
        resizable : false,
        Cell      : field => (<div style={{ textAlign: 'center' }}>{field.value}</div>),
      },
      { 
        Header    : 'Status',
        id        : 'con_status',
        accessor  : 'con_status.sta',
        sortable  : true,
        maxWidth  : 110,
        resizable : false,
        Cell      : field => (<div style={{ textAlign: 'center' }}>{statusTypesLookup(field.value)}</div>),
      },
      { 
        Header    : 'Actions',
        sortable  : false,
        maxWidth  : 150,
        resizable : false,
        Cell      : props => (
          <div style={{ textAlign: 'center' }}>
            <span className="tbl-lnk" onClick={()=>this.editItem(props.original)}>Edit</span>
            &nbsp;|&nbsp;
            <span className="tbl-lnk" onClick={()=>this.copyItem(props.original)}>Copy</span>
            &nbsp;|&nbsp;
            <span className="tbl-lnk" onClick={()=>this.promptForDeletion(props.original)}>Delete</span>
          </div>
        ),
      },
    ];

    return (
      <div>
        <PageHeaderBar
          mode={mode}
          typeSingle="Contributor"
          typePlural="Contributors"
          onCreate={this.createItem}
          onCancel={this.gotoListMode}
          onSave={this.onSaveItem}
        />
        <div style={{ display: mode === 'list' ? 'block' : 'none' }}>
          <AdminTable
            setTableRef={(tableRef) => this.tableRef = tableRef}
            fetchURL={'/api/contributors'}
            notifyError={notifyError}
            columns={columns}
            filters={[
              { title: 'Name',   name: 'con_name',       type: 'text'   },
              { title: 'Status', name: 'con_status.sta', type: 'status' },
            ]}
            defaultSorted={{ id: 'name', desc: false }}
          />
        </div>

        {['create', 'edit', 'copy'].includes(mode) && (
          <ContributorForm ref={this.formRef} item={currentItem} />
        )}

        <Modal
          title={`Delete Contributor: ${currentItem ? currentItem.con_name : ''}`}
          open={deleteModal}
          action="Delete"
          onAction={this.onDeleteCurrentItem}
          onClose={this.onCloseModal}
        />

      </div>
    );
  }
}

export default Contributors;
